@layer design-system {
  .itemWrapper {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  }

  .iconWrapper {
    padding-top: 3px;
  }

  .styledText {
    color: var(--text-default);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    overflow-wrap: break-word;

    &.processing {
      color: var(--text-soft);
    }
  }
}
